import parsePhoneNumber from 'libphonenumber-js';

export function formatInternationalPhone(value, defaultCountry = 'PK') {
  if (!value && value !== 0) return null;

  try {
    const phoneNumber = parsePhoneNumber(value, defaultCountry);
    if (phoneNumber && typeof phoneNumber.isValid === 'function' && phoneNumber.isValid()) {
      return phoneNumber.formatInternational();
    }
    // If invalid or unparsable, return the original input (trimmed)
    return String(value).trim();
  } catch (error) {
    console.error('Error formatting phone number:', error);
    return String(value).trim();
  }
}
export const transformSummary = (summaryData) => {
  if (!summaryData) return {};

  return {
    clientId: summaryData.appointmentId?._id || "",
    summaryId: summaryData._id || "",
    _id: summaryData.appointmentId?._id || "",
    createdAt: summaryData?.created_at || "",
    fullName: summaryData.appointmentId?.fullName || "",
    email: summaryData.appointmentId?.email || "",
    age: summaryData.appointmentId?.age || "",
    dependent: summaryData.appointmentId?.dependent || "",
    visaCategory: summaryData.appointmentId?.visaCategory || "",
    visaStatus: summaryData.appointmentId?.visaStatus || "",
    // phase 2 changes Open
    otherVisaCategory: summaryData.appointmentId?.otherVisaCategory || "",
    // phase 2 changes Close
    nationality: summaryData.appointmentId?.nationality || "",
    // phase 2 changes Open
    country: summaryData.appointmentId?.country || "",
    city: summaryData.appointmentId?.city || "",
    // phase 2 changes Close
    suburb: summaryData.appointmentId?.suburb || "",
    residentialAddress: summaryData.appointmentId?.residentialAddress || "",
    mobileNumber: summaryData.appointmentId?.mobile || "",
    englishLanguageScore: summaryData.appointmentId?.englishLanguageScore || "",
    highestEducationLevel:
      summaryData.appointmentId?.highestEducationLevel || "",
    skillAssessment: summaryData.appointmentId?.skillAssessment || "",
    isStudying: summaryData.appointmentId?.isStudying || "",
    meetAustralianStudyRequirements:
      summaryData.appointmentId?.australianQualification,
    naatiAccredited: summaryData.appointmentId?.isNaati,
    maritalStatus: summaryData.appointmentId?.maritalStatus || "",
    partnerSkills: summaryData.appointmentId?.partnerSkills || "",
    employment: summaryData.appointmentId?.employment || "",
    overseasEmployement: summaryData.appointmentId?.overseasEmployement || "",
    // phase 2 changes Open
    overseasJobTitle: summaryData.appointmentId?.overseasJobTitle || "",
    overseasJobCompanyName:
      summaryData.appointmentId?.overseasJobCompanyName || "",
    overseasJobCompanyCountry:
      summaryData.appointmentId?.overseasJobCompanyCountry || "",
    overseasJobCompanyCity:
      summaryData.appointmentId?.overseasJobCompanyCity || "",
    overseasJobDurationFrom:
      summaryData.appointmentId?.overseasJobDurationFrom || "",
    overseasJobDurationTo:
      summaryData.appointmentId?.overseasJobDurationTo || "",
    overseasJobIsWorking: summaryData.appointmentId?.overseasJobIsWorking || "",
    // phase 2 changes Close
    australianSkilledEmployment:
      summaryData.appointmentId?.australianSkilledEmployment || "",
    isCompletedProfessionalYearAus:
      summaryData.appointmentId?.isCompletedProfessionalYearAus || "",
    purposeOfVisit: summaryData.appointmentId?.purposeOfVisit || "",
    personalInfoNote: summaryData.appointmentId?.personalInfoNote || "",
    visaNote: summaryData.appointmentId?.visaNote || "",
    australianEducationNote:
      summaryData.appointmentId?.australianEducationNote || "",
    courses: summaryData.appointmentId?.courses || "",
    totalPoints: summaryData.totalPoints || 0,
    agePoints: summaryData.agePoints || 0,
    englishLanguagePoints: summaryData.englishPoints || 0,
    highestEducationPoints: summaryData.highestAustralianEducationPoints || 0,
    meetAustralianStudyPoints: summaryData.meetAustralianSudyPoints || 0,
    masterResearchPoints: summaryData.mastersDoctoratePoints || 0,
    currentAgent: summaryData.appointmentId?.currentAgent || "",
    university: summaryData.appointmentId?.university || "",
    degree: summaryData.appointmentId?.degree || "",
    nattiPoints: summaryData.naatiPoints || 0,
    regionalAustralianQualification:
      summaryData.appointmentId?.regionalAustralianQualification || 0,
    partnerPoints: summaryData.spousePoints || 0,
    overseasEmployementPoints: summaryData.overseasEmploymentPoints || 0,
    australianEmploymentPoints: summaryData.australianEmploymentPoints || 0,
    regionalAustralianQualificationPoints:
      summaryData.regionalAustralianQualificationPoints || 0,
    isCompletedProfessionalYearAusPoints:
      summaryData.professionalYearPoints || 0,
  };
};
